// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading,
.error {
  padding: 5px;
  width: 100%;
  height: auto;
  text-align: center;
}
.loading {
  color: gray;
}
.error {
  color: #9b0000;
}
.geometry-info-table {
  border-collapse: collapse;
  width: 100%;
}
.geometry-info-table tr {
  background: #f1f1f1;
}
.geometry-info-table tbody > :nth-child(even) {
  background: #e0e0e0;
}
.geometry-info-table td {
  border: 1px solid #c9c9c9;
  padding: 0 3px 0 3px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/feature_layer/nodepkg/geometry-info/GeometryInfo.less"],"names":[],"mappings":"AAAA;;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACJ;AAEA;EACI,WAAA;AAAJ;AAGA;EACI,cAAA;AADJ;AAIA;EACI,yBAAA;EACA,WAAA;AAFJ;AAAA;EAKQ,mBAAA;AAFR;AAHA;EASQ,mBAAA;AAHR;AANA;EAaQ,yBAAA;EACA,oBAAA;EACA,gBAAA;AAJR","sourcesContent":[".loading,\n.error {\n    padding: 5px;\n    width: 100%;\n    height: auto;\n    text-align: center;\n}\n\n.loading {\n    color: gray;\n}\n\n.error {\n    color: #9b0000;\n}\n\n.geometry-info-table {\n    border-collapse: collapse;\n    width: 100%;\n\n    tr {\n        background: #f1f1f1;\n    }\n\n    tbody > :nth-child(even) {\n        background: #e0e0e0;\n    }\n\n    td {\n        border: 1px solid #c9c9c9;\n        padding: 0 3px 0 3px;\n        text-align: left;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
